export const urlLanguageMapping: Record<string, string[]> = {
  '/prime/': ['es', 'pt', 'th', 'ko', 'zh-hant', 'zh-hans', 'jp'],
  '/terms-and-conditions-no-deposit-credit-offer/': ['th', 'es', 'pt'],
  '/legal/regulatory-environment/': ['th', 'es', 'pt', 'ko', 'zh-hant', 'zh-hans', 'jp'],
  '/elite-account-terms-and-conditions/': ['en', 'pt', 'es'],
  '/terms-and-conditions-super-christmas-rewards-latam/': ['th'],
  '/terms-and-conditions-super-christmas-rewards-nigeria/': ['th', 'pt', 'es'],
  '/partners/': ['ko'],
  '/partners/ib-portal/': ['ko'],
  '/privacy-notice-hml/': ['es', 'pt', 'th', 'ko', 'zh-hant', 'zh-hans', 'jp']
}

export function isLanguageAvailable(url: string, language: string): boolean {
  url = url.replace(/^\/(en|es|pt|th|ko|zh-hans|zh-hant|jp)(\/|$)/, '/')
  if (url in urlLanguageMapping) {
    const unavailableLanguages = urlLanguageMapping[url]
    return !unavailableLanguages.includes(language)
  } else {
    return true
  }
}
